import React from 'react';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import { ErrorOutline as ErrorIcon } from '@mui/icons-material';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
        // You can log the error to an error reporting service here
        console.error('ErrorBoundary caught an error:', error, errorInfo);
    }

    handleReload = () => {
        window.location.reload();
    };

    handleGoHome = () => {
        window.location.href = '/dashboard';
    };

    render() {
        if (this.state.hasError) {
            return (
                <Container maxWidth="sm" sx={{ mt: 8 }}>
                    <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
                        <ErrorIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
                        <Typography variant="h4" gutterBottom>
                            {this.props.title || 'Something went wrong'}
                        </Typography>
                        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                            {this.props.message || 'An unexpected error occurred. Please try again.'}
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                            <Button variant="contained" onClick={this.handleReload}>
                                Reload Page
                            </Button>
                            <Button variant="outlined" onClick={this.handleGoHome}>
                                Go to Dashboard
                            </Button>
                        </Box>
                        {process.env.NODE_ENV === 'development' && this.state.error && (
                            <Box sx={{ mt: 3, textAlign: 'left' }}>
                                <Typography variant="caption" component="pre" sx={{
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word',
                                    backgroundColor: 'grey.100',
                                    p: 2,
                                    borderRadius: 1,
                                    fontSize: '0.75rem'
                                }}>
                                    {this.state.error.toString()}
                                    {this.state.errorInfo?.componentStack}
                                </Typography>
                            </Box>
                        )}
                    </Paper>
                </Container>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
